import { getAirdropApiUrl } from './common';
import { formatEther } from 'viem';
import { getPublicClient } from './getPublicClient';
import { GAS_COST_MAP } from 'pages/TransferPage/TransferPage.constants';
import { tracker } from './tracker';
import { nanoid } from 'nanoid';
export const requestAirdrop = async (chainId, address) => {
    const requiredBalance = GAS_COST_MAP[chainId] ?? 0;
    const balance = await getPublicClient()
        .getBalance({
        address,
    })
        .then(formatEther);
    if (parseFloat(balance) >= requiredBalance) {
        return false;
    }
    const captchaToken = tracker.getCaptchaToken();
    let idempotencyKey = tracker.getIdempotencyKey();
    if (!captchaToken) {
        console.error('CAPTCHA verification required before requesting an airdrop');
    }
    if (!idempotencyKey) {
        idempotencyKey = nanoid();
        tracker.setIdempotencyKey(idempotencyKey);
    }
    const response = await fetch(`${getAirdropApiUrl(chainId)}/fundAddress`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            address,
            'cf-turnstile-response': captchaToken,
            idempotency_key: idempotencyKey,
        }),
    });
    const data = await response.json();
    console.log('Airdrop response:', data);
    // add delay to allow the transaction to be mined
    await new Promise(resolve => setTimeout(resolve, 5000));
    return true;
};
